import Report from "../../components/Report/Report";
import "../PageCommon.css";
import "./Report.css";

const ReportPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <Report />
        </div>
      </div>
    </div>
  );
}

export default ReportPage;